export default function Spin(props) {
  const speed = props.rotate_time || 2000
  return <span
    className={`spin-container ${props.disabled ? '' : 'spin'}`}
    style={{ 
      animationDuration: `${speed}ms`,
    }}
  >
    {props.children}
  </span>
}